var EChartType;
(function (EChartType) {
    EChartType["PLAIN"] = "plain";
    EChartType["DYNAMIC"] = "dynamic";
})(EChartType || (EChartType = {}));
const SPECIAL_CHARS = '?+-()[]{}.,\\/-=_~`|\'" ';
const MASK_PATTERNS = {
    '0': /^[0-9]+$/,
    A: /^[A-Za-zА-Яа-я]+$/,
    Ы: /^[А-Яа-я]+$/,
};
export default class Maskit {
    constructor(input, options = {}) {
        this.value = '';
        this.mask = [];
        this.filled = false;
        this.onBlur = () => {
            const { onBlur, resetOnBlurIfInvalid } = this.options;
            if (resetOnBlurIfInvalid && this.value.length !== this.mask.length) {
                this.setValue('');
                setTimeout(() => {
                    if ('createEvent' in document) {
                        const event = document.createEvent('HTMLEvents');
                        event.initEvent('change', false, true);
                        this.input.dispatchEvent(event);
                    }
                    else {
                        this.input.fireEvent('onchange');
                    }
                }, 0);
            }
            onBlur === null || onBlur === void 0 ? void 0 : onBlur({ instance: this });
        };
        if (!(input instanceof HTMLInputElement)) {
            throw new Error('First argument must be DOM element');
        }
        this.options = options;
        this.input = input;
        this.value = this.input.value || '';
        this.input.value = '';
        if (options.mask) {
            this.mask = this.getMask(options.mask);
        }
        this.init();
    }
    getMask(mask) {
        const result = [];
        for (let i = 0; i < mask.length; i++) {
            if (mask[i] === '{' && mask[i + 2] === '}') {
                result.push({
                    type: EChartType.PLAIN,
                    value: mask[i + 1],
                });
                i += 2;
                continue;
            }
            if (SPECIAL_CHARS.includes(mask[i])) {
                result.push({
                    type: EChartType.PLAIN,
                    value: mask[i],
                });
            }
            else {
                result.push({
                    type: EChartType.DYNAMIC,
                    value: mask[i],
                });
            }
        }
        return result;
    }
    checkMaskChar(char, index, maskInc) {
        const maskChar = this.mask[index];
        let result = '';
        if (!maskChar) {
            return result;
        }
        if (maskChar.type === EChartType.PLAIN) {
            result += maskChar.value;
            result += this.checkMaskChar(char, index + 1, maskInc);
        }
        else if (maskChar.type === EChartType.DYNAMIC) {
            const pattern = MASK_PATTERNS[maskChar.value];
            if (pattern && pattern.test(char)) {
                result += char;
            }
        }
        if (result.length) {
            maskInc();
        }
        return result;
    }
    checkMask(value) {
        if (!this.mask.length) {
            return value;
        }
        let nextValue = '';
        let maskIndex = 0;
        for (let i = 0; i < value.length; i++) {
            if (!this.mask[maskIndex]) {
                break;
            }
            const char = value[i];
            const maskChar = this.mask[maskIndex];
            if (char === maskChar.value) {
                nextValue += char;
                maskIndex++;
            }
            else {
                nextValue += this.checkMaskChar(char, maskIndex, () => {
                    maskIndex++;
                });
            }
        }
        return nextValue;
    }
    prepareAndSetValue() {
        if (!this.value) {
            return;
        }
        let nextValue = '';
        for (let i = 0; i < this.value.length; i++) {
            const maskChar = this.mask[i];
            if (!maskChar)
                break;
            const char = this.value[i];
            if (maskChar.type === 'plain') {
                if (maskChar.value === char) {
                    nextValue += char;
                }
                else {
                    break;
                }
            }
            else if (maskChar.type === 'dynamic') {
                const pattern = MASK_PATTERNS[maskChar.value];
                if (pattern && pattern.test(char)) {
                    nextValue += char;
                }
                else {
                    break;
                }
            }
        }
        this.setValue(nextValue);
    }
    setMask(mask) {
        this.mask = this.getMask(mask);
        this.prepareAndSetValue();
    }
    onFilled() {
        var _a, _b;
        this.filled = true;
        (_b = (_a = this.options).onFilled) === null || _b === void 0 ? void 0 : _b.call(_a, { instance: this });
    }
    offFilled() {
        var _a, _b;
        this.filled = false;
        (_b = (_a = this.options).offFilled) === null || _b === void 0 ? void 0 : _b.call(_a, { instance: this });
    }
    setValue(value) {
        var _a, _b;
        if (this.value === value) {
            this.input.value = value;
            return;
        }
        this.input.value = value;
        this.value = value;
        (_b = (_a = this.options).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, { instance: this });
        if (value.length === this.mask.length) {
            this.onFilled();
        }
        else {
            this.offFilled();
        }
    }
    inputListener() {
        this.input.addEventListener('input', (event) => {
            const target = event.target;
            let value = target.value;
            const { beforeChange } = this.options;
            if (beforeChange) {
                const nextVlaue = beforeChange({
                    instance: this,
                    value,
                });
                if (nextVlaue) {
                    value = nextVlaue;
                }
            }
            this.setValue(this.checkMask(value));
        });
    }
    blurListener() {
        this.input.addEventListener('blur', this.onBlur);
    }
    runListeners() {
        this.inputListener();
        this.blurListener();
    }
    init() {
        var _a, _b;
        this.prepareAndSetValue();
        this.runListeners();
        (_b = (_a = this.options).onInit) === null || _b === void 0 ? void 0 : _b.call(_a, { instance: this });
    }
    getValue() {
        return this.value;
    }
    isFilled() {
        return this.filled;
    }
}
